module.exports = __webpack_public_path__ + "static/img/02038B_1_R_20201106_LC.b26d402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02038B_1_R_20201106_LC.png
// module id = xFxm
// module chunks = 0